import axios from "axios";
import { serviceUrl } from "../../config";

const BACKEND_URL = serviceUrl;

export const createExternalAccounts = async (requestdata, userid, agentID, isOperator, parentuserid) => {
  try {
    const data = JSON.stringify({
      svc: "externalaccounts",
      pid: "addAccounts",
      dat: {
        ...requestdata,
        userid: userid,
        agentID: agentID,
        isOperator: isOperator,
        parentuserid: parentuserid
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getExternalAccounts = async (userid) => {
  try {
    const data = JSON.stringify({
      svc: "externalaccounts",
      pid: "getConsumerAccounts",
      dat: {
        userid: userid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getBlockedMC = async (userid) => {
  try {
    const data = JSON.stringify({
      svc: "externalaccounts",
      pid: "getBlockedMC",
      dat: {
        userid: userid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getExternalAccountBalance = async (userid, piid) => {
  try {
    const data = JSON.stringify({
      svc: "externalaccounts",
      pid: "GetExternalAccountBalance",
      dat: {
        userid: userid,
        piid: piid
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
}